export default {
  isSound: true,
  isMusic: false,
}